import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-by-userid',
  templateUrl: './edit-by-userid.component.html',
  styleUrls: ['./edit-by-userid.component.scss'],
})
export class EditByUseridComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;
  submitted = false;
  EditByUserID: FormGroup;
  currentUser: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private gs: GeneralService,
    private fb: FormBuilder,
    private datepipe: DatePipe
  ) {}

  Epp = [];
  ActiveArray = [
    {
      name: 'InActive',
      value: 0,
    },
    {
      name: 'Active',
      value: 1,
    },
  ];

  selectedValue = this.ActiveArray[0];
  selectedUser = null;

  ngOnInit() {
    this.currentUser = this.gs.getcurrentUser();
    this.breadCrumbItems = [
      {
        label: 'EPP',
        path: '/',
      },
      { label: 'Edit EPP', path: 'EditById/:UserID', active: true },
    ];

    this.EditByUserID = new FormGroup({
      start_date: new FormControl(null, Validators.required),
      end_date: new FormControl(null, Validators.required),
      // active: new FormControl(null, Validators.required),
      Admin_ID: new FormControl(this.currentUser.Id),
      EPP_In_Days: new FormControl(30, [Validators.min(0),Validators.required]),
    });

    this.gs
      .getEppByUserId(this.route.snapshot.params.UserID)
      .subscribe((Response: any) => {
        this.Epp = Response.data;
        console.log(Response.data);

        this.Epp.map((item) => {
          // console.log(item);

          item.start_date = this.datepipe.transform(
            item.start_date,
            'yyyy-MM-dd'
          );
          item.end_date = this.datepipe.transform(item.end_date, 'yyyy-MM-dd');
          // item.active = item.active = 1 ? 'Active' : 'Inactive';
        });
        this.EditByUserID.patchValue(this.Epp[0]);
        // console.log(this.Epp[0].active);
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
  }
  get f() {
    return this.EditByUserID.controls;
  }

  onSubmit() {
    this.submitted = true;
    // console.log(this.route.snapshot.params.UserID, this.EditByUserID.value);
    if (this.EditByUserID.valid) {
      this.submitted = false;
      Swal.fire({
        title: 'Are you sure, you want to update this for all survey no.?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        this.submitted = false;
        if (result.value) {
          this.isLoading = true;
          this.gs
            .UpdateEppByUserId(
              this.route.snapshot.params.UserID,
              this.EditByUserID.value
            )
            .subscribe((data) => {
              this.isLoading = false;
              if (data.status === 200) {
                Swal.fire({
                  title: 'Epp Updated Sucessfully',
                  text: data.message,
                  type: 'success',
                }).then(() => {
                  this.router.navigate(['']);
                });
              } else {
                Swal.fire({
                  title: data.error_code,
                  text: data.message,
                  type: 'error',
                });
              }
            },(error) => {                              //Error callback
              this.isLoading = false;
              Swal.fire({
                title: error.status,
                text: "Internal Server Error",
                type: "error",
              });
              //throw error;   //You can also throw the error to a global error handler
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
        this.submitted = false;
      });
    }
  }
  SetEndDate() {
    var date = new Date(this.EditByUserID.controls.start_date.value);
    this.EditByUserID.controls.end_date.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }
  add_years(dt,n) 
  {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }

}
